export default __webpack_public_path__ + "static/logo-25c3dc125cfdfeee72c1fdff1ece1c7a.svg";